import React from 'react';
import classNames from 'classnames';

import 'react-toastify/dist/ReactToastify.css';
import {UnreceivedTransStatus, UnreceivedTransStatusMessage} from "../utils/unreceived";
import {formatMoney} from "../utils/common";
import {PopupConfirm} from "../containers/Main/Popup/ConfirmPopup";

const TrxSuccess = 'ok';
const TrxFailed = 'failed';
const TrxPending = 'pending';
const TrxCreated = 'created';

const getTrxStatus = (transaction) => {
  if (transaction.resubmit_state === UnreceivedTransStatus.SUCCESS) {
    return TrxSuccess;
  }

  if (transaction.resubmit_state === UnreceivedTransStatus.FAILED) {
    return TrxFailed;
  }

  if (transaction.resubmit_state === UnreceivedTransStatus.INITIATED) {
    return TrxCreated;
  }

  return TrxPending;
};

const getActionBtnCls = (trxStatus) => {
  if (trxStatus === TrxCreated) {
    return 'btn-primary';
  }

  return 'btn-secondary';
};

const canResubmit = (trxStatus) => {
  return trxStatus === TrxCreated;
};

export const convertAmountToVndFormat = (amount) => {
  return formatMoney(amount, 0, '') + ' VNĐ';
};

export const getTransactionMsg = (trxTime, trxAmount) => {
  return <span>
      giao dịch tại thời điểm&nbsp;
    <span className='text-warning'>{trxTime}</span> với số tiền <span className='text-success'>{convertAmountToVndFormat(trxAmount)}</span>
  </span>;
};

export const UnreceivedTransaction = React.memo(({ transaction, onResubmit }) => {
  const {
    partner_transaction_time: trxTime,
    sender_account_name: senderName,
    sender_account_no: senderNo,
    bank_name: bankName,
    amount,
  } = transaction ?? {};

  const trxStatus = getTrxStatus(transaction);
  const amountVndFormat = convertAmountToVndFormat(amount);

  // logic resubmit trans
  const handleConfirmResubmit = () => {
    if (typeof onResubmit === 'function') {
      onResubmit(transaction);
    }
  };

  const handleCancelResubmit = () => {
  };

  const confirmMsg = <span>Ghi nhận {getTransactionMsg(trxTime, amount)}</span>;

  const trxActions = () => {
    return <>
      <button
        data-tip
        data-for='resubmit'
        className={classNames('btn', getActionBtnCls(trxStatus))}
        role='button'
        aria-pressed='true'
        data-toggle='modal'
        data-target='#unreceived-confirm'
        disabled={!canResubmit(trxStatus)}
      >
        {!canResubmit(trxStatus) ? <img
          src='/cashier/shop/static/assets/images/icon_slash.svg'
          style={{ width: '16px', height: '16px', marginRight: '4px', marginBottom: '2px'}}
          alt='slash icon' /> : undefined}
          Ghi nhận
      </button>
    </>;
  };

  return (
    <>
      <PopupConfirm
        isOpen={true}
        id='unreceived-confirm'
        title='Xác nhận'
        content={confirmMsg}
        onConfirm={handleConfirmResubmit}
        onCancel={handleCancelResubmit}
      />
      <tr>
        <td className='text-center'>
          <div className='cell-date'>{trxTime}</div>
        </td>
        <td className='text-center'>
          <div className='cell-title'>Tên tài khoản</div>
          <div className='cell-data'>{senderName}</div>
        </td>
        <td className='text-center'>
          <div className='cell-title'>Số tài khoản</div>
          <div className='cell-data'>{senderNo}</div>
        </td>
        <td className='text-center'>
          <div className='cell-title'>Số tiền</div>
          <div className={classNames('cell-data', 'ok')}>
            {amountVndFormat}
          </div>
        </td>
        <td className='text-center'>
          <div className='cell-title'>Tên ngân hàng</div>
          <div className='cell-data'>{bankName}</div>
        </td>
        <td className='text-center'>
          <div className='cell-title'>Tình trạng</div>
          <div className={classNames('cell-data', `status_${trxStatus}`)}>
            {UnreceivedTransStatusMessage[transaction.resubmit_state]}
          </div>
        </td>
        <td className='text-center'>
          <div className='cell-title'>Hành động</div>
          <div className='cell-data'>
            {trxActions()}
          </div>
        </td>
      </tr>
    </>

  );
});

export const UnreceivedTransactionTable = React.memo((props) => {
  return (
    <div className='responsive-full-wrap'>
      <table className='table w-100 transactions'>
        <thead>
          <tr>
            <th width='200' className='text-center'>THỜI ĐIỂM</th>
            <th width='200' className='text-center'>TÊN TÀI KHOẢN</th>
            <th width='150' className='text-center'>SỐ TÀI KHOẢN</th>
            <th width='150' className='text-center'>SỐ TIỀN</th>
            <th width='150' className='text-center'>TÊN NGÂN HÀNG</th>
            <th width='150' className='text-center'>TÌNH TRẠNG</th>
            <th width='150' className='text-center'>HÀNH ĐỘNG</th>
          </tr>
        </thead>
        <tbody>
          {props.children}
        </tbody>
      </table>
    </div>
  );
});
